import { TranslocoMissingHandler } from '@ngneat/transloco';

export class LacertaTranslationMissingHandler implements TranslocoMissingHandler {
  handle() {
    return '';
  }
}
